import React from "react";
import badge_images from "../../../images/badges";
import UncontrolledTooltip from "reactstrap/src/UncontrolledTooltip";
import {FormattedMessage} from "react-intl";

class Badge extends React.Component {
    render() {
        const { identifier, code, progress_states } = this.props;
        const active = progress_states.some((state) => state.identifier === identifier && state.data && state.data.achieved === true );

        return (
            <div className='trophies-list__item'>
                <img onClick={() => { this.setState({ isOpen: true }) }} src={ badge_images[active ? 'active' : 'gray'][code]} id={`badge-${code}`}/>
                <UncontrolledTooltip className='large-tooltip' target={`#badge-${code}`}>
                    <h6 className='text-gray'><FormattedMessage id={`app.badges.${code}.title`}/></h6>
                    <div><FormattedMessage id={`app.badges.${code}.${active ? 'active_text' : 'requirements'}`}/></div>
                </UncontrolledTooltip>
            </div>
        );
    }
}

export default Badge;
